import createReducer from 'shared/utils/createReducer';
import { LOGIN } from 'modules/auth/actions/login';
import { LOGOUT } from 'modules/auth/actions/logout';

import { USER_UPDATED } from 'modules/common/actions/onUserUpdates';
import { ARCHIVED } from 'modules/queues/constants/queueEnforcementTypes';
import { SHOW_APPOINTMENT_INFO } from 'modules/queues/common/actions/appointmentInfo';
import { ADD_GROUP_APPOINTMENT_TO_SCOPE } from 'modules/queues/common/actions/onGroupAppointmentsUpdates';
import { SCROLL_RESTORED, APPOINTMENT_SIZE_UPDATED } from 'modules/queues/Archive/actions/appointmentsScroll';

import {
  ADD_APPOINTMENT_TO_LIST,
  REMOVE_APPOINTMENT_FROM_LIST,
  UPDATE_EXISTING_APPOINTMENT,
} from 'modules/queues/common/actions/appointmentsListActions';

const defaultState = {
  scrollToAppointmentId: null,
  shouldUpdateListCache: false,
};

export default createReducer(defaultState, {
  [SCROLL_RESTORED]: (state) => ({
    ...state,
    scrollToAppointmentId: null,
  }),

  [SHOW_APPOINTMENT_INFO]: (state, { payload: { appointmentId } }) => ({
    ...state,
    scrollToAppointmentId: appointmentId,
  }),

  [UPDATE_EXISTING_APPOINTMENT]: (state, { payload: { listQueueType } }) => {
    if (listQueueType !== ARCHIVED) return state;

    return {
      ...state,
      shouldUpdateListCache: true,
    };
  },

  [ADD_APPOINTMENT_TO_LIST]: (state, { payload: { listQueueType } }) => {
    if (listQueueType !== ARCHIVED) return state;

    return {
      ...state,
      shouldUpdateListCache: true,
    };
  },

  [REMOVE_APPOINTMENT_FROM_LIST]: (state, { payload: { listQueueType } }) => {
    if (listQueueType !== ARCHIVED) return state;

    return {
      ...state,
      shouldUpdateListCache: true,
    };
  },

  [APPOINTMENT_SIZE_UPDATED]: state => ({
    ...state,
    shouldUpdateListCache: false,
  }),

  [USER_UPDATED]: (state) => ({
    ...state,
    shouldUpdateListCache: true,
  }),

  [ADD_GROUP_APPOINTMENT_TO_SCOPE]: (state) => ({
    ...state,
    shouldUpdateListCache: true,
  }),

  [LOGIN.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
